import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithRedirect,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc ,collection, writeBatch, query, getDocs} from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCV-RzCXxqrk9fGOigA29G7pr5mPe3aU3M",
  authDomain: "crwn-clothing-db-e245c.firebaseapp.com",
  projectId: "crwn-clothing-db-e245c",
  storageBucket: "crwn-clothing-db-e245c.appspot.com",
  messagingSenderId: "1058016136189",
  appId: "1:1058016136189:web:f2bffd9a729d10f421a794",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});

export const auth = getAuth();
export const signInWithEmailAndPasswordHandler = async (email, password) => {
  if (!email || !password) return;

  return signInWithEmailAndPassword(auth, email, password);
};
export const signInWithGooglePopup = () =>
  signInWithPopup(auth, googleProvider);
export const signInWithGoogleRedirect = () =>
  signInWithRedirect(auth, googleProvider);

export const db = getFirestore();

export const addCollectionAndDocuments = async(collectionKey, objectsToAdd) => {
  const collectionRef = collection(db, collectionKey);
  const batch = writeBatch(db);

  objectsToAdd.forEach((object)=>{
    const docRef = doc(collectionRef,object.title.toLowerCase());
    batch.set(docRef,object);
  })

  await batch.commit();
  console.log("done");
};

export const getCategoriesAndDocuments = async() =>{
  const collectionRef = collection(db,'categories')
  const q = query(collectionRef);
  const querySnapshot = await getDocs(q);
  const categoryMap = querySnapshot.docs.reduce((acc, docSnapshot)=>{
    const {title, items} = docSnapshot.data();
    acc[title.toLowerCase()] = items;
    return acc;
  },{})

  return categoryMap; 
}

export const createUserDocumentFromAuth = async (
  userAuth,
  additionalInformation = {}
) => {
  if (!userAuth) return;

  const userDocRef = doc(db, "users", userAuth.uid);

  const userSnapshot = await getDoc(userDocRef);

  if (!userSnapshot.exists()) {
    const { displayName, email } = userAuth;
    const createdAt = new Date();

    try {
      await setDoc(userDocRef, {
        displayName,
        email,
        createdAt,
        ...additionalInformation,
      });
    } catch (error) {
      console.log("Error creating user", error.message);
    }
  }
  return userDocRef;
  //return userdocref
};

export const createAuthUserwithEmailandPassword = async (email, password) => {
  if (!email || !password) return;
  try {
    const { user } = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    return user;
  } catch (error) {
    console.log("Error creating user", error.message);
  }
};
export const signOutUser = async() => signOut(auth);

export const onAuthStateChangedListener = (callback) => onAuthStateChanged(auth, callback) 